<template>
  <div class="d-print-none">
    <v-list nav >
      <v-list-item :to="{ name: 'DashboardView' }">
         <v-list-item-icon>
        <v-avatar size="40">
          <v-img
            :src="account.profile_image_url"
            :alt="account.name"
          ></v-img>
        </v-avatar>
        </v-list-item-icon>
        <v-list-item-title>{{ account.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav dense>
      <template v-for="(item, index) in menu">
        <v-list-item v-if="account.permissions.includes(item.permission) || item.permission ==0" link :to="item.route" :key="index">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
        <v-divider
          :key="index + '-divider'"
          v-if="item.divider"
          class="py-1"
        ></v-divider>
      </template>
    </v-list>
  </div>
</template>
  
  
  <script>
import { mapState } from "vuex";
import menu from "@/datasets/menu";
export default {
  computed: mapState({
    account: (state) => state.account.data,
  }),
  data: () => ({
    menu: [],
    //BOC:[type]
    type: null,
    //EOC
  }),
  created() {
    this.type = this.account.role;
    this.menu = this.$_.clone(menu["Menu"]);
    this.menu.unshift({
      name: "Dashboard",
      icon: "mdi-view-dashboard",
      route: { name: "DashboardView" },
      permission: 0,
    });
    this.menu.push({
      name: "Log Out",
      icon: "mdi-exit-run",
      route: { name: "LogoutView" },
      permission: 0,
    });
  },
};
</script>
  